<template>
  <div class="personconfig-box">
    <div class="personconfig-content-wrap">
      <img src="@/assets/business/person_img.png" alt="" />
      <!-- 内容部分 -->
      <div class="personconfig-bottom">
        <div class="personconfig-left">
          <div class="en-title">{{ "config".toUpperCase() }}</div>
          <div class="cn-title">人力资源配置</div>
          <div
            class="personconfig-content-box"
            v-html="cleanHtmlText(data.content)"
          ></div>
        </div>
        <div class="right">
          <img src="@/assets/business/img6.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
